import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { useData } from '../../context/DataContext';
import { computeReviewStatus, getWeekReview } from '../../data/mockData';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
interface LeaderboardProps {
  rvpId?: string;
}
export function Leaderboard({
  rvpId
}: LeaderboardProps) {
  const {
    managers,
    loanOfficers,
    selectedWeek
  } = useData();
  const filteredManagers = rvpId ? managers.filter(m => m.rvpId === rvpId) : managers;
  const managerStats = filteredManagers.map(m => {
    const los = loanOfficers.filter(lo => lo.managerId === m.id);
    const avgScore = Math.round(los.reduce((acc, lo) => acc + lo.accountabilityScore, 0) / (los.length || 1));
    const completed = los.filter(lo => computeReviewStatus(getWeekReview(lo, selectedWeek)) === 'complete').length;
    const completionRate = Math.round(completed / (los.length || 1) * 100);
    return {
      name: m.name,
      avgScore,
      completionRate,
      team: m.team
    };
  }).sort((a, b) => b.avgScore - a.avgScore);
  return <Card className="col-span-2" data-id="element-25">
      <CardHeader data-id="element-26">
        <CardTitle data-id="element-27">Manager Accountability Leaderboard</CardTitle>
      </CardHeader>
      <CardContent data-id="element-28">
        <div className="h-[300px] w-full" data-id="element-29">
          <ResponsiveContainer width="100%" height="100%" data-id="element-30">
            <BarChart data={managerStats} margin={{
            top: 20,
            right: 30,
            left: 0,
            bottom: 5
          }} data-id="element-31">
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" data-id="element-32" />
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
              fill: '#64748b',
              fontSize: 12
            }} data-id="element-33" />
              <YAxis axisLine={false} tickLine={false} tick={{
              fill: '#64748b',
              fontSize: 12
            }} data-id="element-34" />
              <Tooltip cursor={{
              fill: '#f8fafc'
            }} contentStyle={{
              borderRadius: '8px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} data-id="element-35" />
              <Bar dataKey="avgScore" name="Avg Score" radius={[4, 4, 0, 0]} data-id="element-36">
                {managerStats.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.avgScore >= 80 ? '#0f172a' : entry.avgScore >= 60 ? '#64748b' : '#cbd5e1'} data-id="element-37" />)}
              </Bar>
              <Bar dataKey="completionRate" name="Completion %" fill="#e2e8f0" radius={[4, 4, 0, 0]} barSize={12} data-id="element-38" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>;
}